/**
 * Mode options for the Item Picker component
 */
export var ItemPickerMode;
(function (ItemPickerMode) {
    ItemPickerMode["Tabs"] = "Tabs";
    ItemPickerMode["List"] = "List";
})(ItemPickerMode || (ItemPickerMode = {}));
